import { render } from "./LocationList.vue?vue&type=template&id=2d5d108e&scoped=true"
import script from "./LocationList.vue?vue&type=script&lang=js"
export * from "./LocationList.vue?vue&type=script&lang=js"

import "./LocationList.vue?vue&type=style&index=0&id=2d5d108e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5d108e"]])

export default __exports__